import { render, staticRenderFns } from "./ProjectOrderStatistics.vue?vue&type=template&id=f38714d2&scoped=true&"
import script from "./ProjectOrderStatistics.vue?vue&type=script&lang=js&"
export * from "./ProjectOrderStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f38714d2",
  null
  
)

export default component.exports